import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from 'store/hooks';
import { ROUTE_PATHS } from 'utils/constants';

interface ProtectedRouteProps {
  children?: any;
  path: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  path
}) => {
  const profile = useAppSelector((state) => state.auth.profile);

  if (!profile) {
    return <Navigate to={ROUTE_PATHS.LOGIN} state={{ path }} />;
  }
  return children;
};

export default ProtectedRoute;
